import { render } from "./UpdateUserPassword.vue?vue&type=template&id=73fb7db6"
import script from "./UpdateUserPassword.vue?vue&type=script&lang=js"
export * from "./UpdateUserPassword.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/farmfeed-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__